/** Orden de entrada tras login: el mismo que la navegación principal (AppMainHeader). */
const HOME_ORDER = [
  ["candidatos", "/candidatos"],
  ["formularios", "/formularios"],
  ["onboarding", "/onboarding"],
  ["revisiones", "/revisiones"],
  ["proveedores", "/proveedores"],
  ["archivos", "/brutalfiles"],
  ["metricas", "/metricas"],
  ["correos", "/correos"],
  ["gmb", "/gmb"],
  ["material", "/material"],
  ["artefactos", "/artefactos"],
  ["admin", "/dashboard"],
];

/** Primera página a la que el usuario tiene acceso (permisos ya normalizados), o null si ninguna. */
export function getHomePath(permissions) {
  const perms = permissions || {};
  const hit = HOME_ORDER.find(([perm]) => perms[perm] !== false);
  return hit ? hit[1] : null;
}
